import { ExtendableError } from './extendableError.mjs';

export class ForbiddenError extends ExtendableError {}
